<div class="ar-map">
  <!-- Back button for safe navigation -->
  <button class="back-button" (click)="goBack()">
    <i class="fas fa-arrow-left"></i>
  </button>

  <a-scene
    vr-mode-ui="enabled: false"
    renderer="antialias: false; precision: medium; logarithmicDepthBuffer: false;"
    arjs="sourceType: webcam; videoTexture: true; debugUIEnabled: false; detectionMode: mono_and_matrix; matrixCodeType: 3x3; sourceWidth: 1080; sourceHeight: 1920; displayWidth: 1080; displayHeight: 1920;"
  >
    <a-entity
      look-at="[gps-camera]"
      camera
      gps-entity-place="latitude: {{ graveLatitude }}; longitude: {{ graveLongitude }};"
    >
      <a-cone
        color="red"
        height="1"
        radius-bottom="0"
        radius-top="0.2"
        position="0 0.5 0"
      ></a-cone>
      <a-sphere color="red" radius="0.2" position="0 1.15 0"></a-sphere>
    </a-entity>
    <a-camera gps-camera rotation-reader> </a-camera>
  </a-scene>
</div>
